import { usePostMutation } from "@/api/swr/useMutation";
import { registerCompanySchema } from "@/schema/RegisterCompany";
import { z } from "zod";

const registerCompanyResSchema = z.object({
  id: z.number(),
});

type Config = Parameters<
  typeof usePostMutation<
    typeof registerCompanySchema,
    typeof registerCompanyResSchema
  >
>[3];

export function useRegisterCompany(config: Config) {
  return usePostMutation(
    registerCompanySchema,
    registerCompanyResSchema,
    "/companies",
    config,
  );
}
